import { ApiErrorMessage, BaseApi } from "api";
import { endpoints } from "config";
import {
  GetCoordinatesParams,
  GetCoordinatesResponse,
} from "./getCoordinatesModels";

class GetCoordinatesApi extends BaseApi {
  private static getCoordinatesParseError: typeof this.parseGenericErrorMessageCode =
    (msg) => {
      switch (msg) {
        // API-specific error codes here, generic messages handled below
        default:
          return this.parseGenericErrorMessageCode(msg);
      }
    };

  /**
   * # Get the coordinates of a point in the panorama
   */
  static getCoordinates = async (params: GetCoordinatesParams) => {
    try {
      const result = await this.makeRequest<
        GetCoordinatesResponse,
        ApiErrorMessage[]
      >({
        url: endpoints.features.getCoordinates,
        method: "GET",
        config: {
          params,
        },
      });
      if (this.isResponseSuccessful(result)) {
        return this.successResponse(result.data.details);
      } else {
        return this.errorResponse(
          this.getCoordinatesParseError(result.data.errors[0].message_code)
        );
      }
    } catch (err: unknown) {
      return this.safelyCatchUnknownError<GetCoordinatesResponse>(
        err,
        "getCoordinates",
        this.getCoordinatesParseError
      );
    }
  };
}

export default GetCoordinatesApi;
